/**
 * Authentication Service
 * All authentication-related API calls
 */

import { api } from '../../../shared/services/apiClient';

const authService = {
  /**
   * Login / Authenticate user
   */
  authenticate: async (credentials) => {
    const response = await api.post('/Login/Authenticate', credentials);
    return response.data;
  },

  /**
   * Forgot password - request OTP
   */
  forgotPassword: async (userData) => {
    const response = await api.post('/Login/ForgetPassword', userData);
    return response.data;
  },

  /**
   * Verify OTP for forgot password
   */
  verifyOTP: async (otpData) => {
    const response = await api.post('/Login/ForgotpasswordCheckOtp', otpData);
    return response.data;
  },

  /**
   * Reset password using OTP
   */
  resetPassword: async (resetData) => {
    const response = await api.post('/Login/ChangePasswordFromOTP', resetData);
    return response.data;
  },

  /**
   * Change password (logged in user)
   */
  changePassword: async (changeData) => {
    const response = await api.post('/Login/ChangePassword', changeData);
    return response.data;
  },

  /**
   * Get roles for employee
   */
  getRoles: async (employeeCode) => {
    const response = await api.get(`/Login/GetRole?EmployeeCode=${employeeCode}`);
    return response.data;
  },

  /**
   * Get sidebar dropdown list
   */
  getSidebarDropdownList: async (employeeId) => {
    const response = await api.get(`/Login/SidebarDropdownList?EmployeeId=${employeeId}`);
    return response.data;
  },

  /**
   * Get sidebar dropdown selected
   */
  getSidebarDropdownSelected: async (roleID) => {
    const response = await api.get(`/Login/SidebarDropdownSelected?RoleID=${roleID}`);
    return response.data;
  },

  /**
   * Set logout time
   */
  setLogoutTime: async (empID) => {
    const response = await api.get(`/Login/SetLogoutTime?Id=${empID}`);
    return response.data;
  }
};

export default authService;

